import React, { useState, useEffect } from 'react';
import { Card, Button } from 'react-bootstrap';
import { FaCheck, FaTimes } from 'react-icons/fa';
import ContactFormSection from './ContactFormSection';
import { validateContactForm } from './ContactFormUtils';
import {useTranslation} from 'react-i18next'

const ContactEditor = ({ formData, currentUser, onSave, onCancel, formErrors }) => {
    // Local state for form data
    const [localData, setLocalData] = useState(formData || {});
    const [touched, setTouched] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);

    const {t} = useTranslation('contact')

    // Update local data when form data changes
    useEffect(() => {
        setLocalData(formData || {});
    }, [formData]);

    // Validate form whenever local data changes
    useEffect(() => {
        const errors = validateContactForm(localData);
        setIsFormValid(Object.keys(errors).length === 0);
    }, [localData]);

    // Handle changes to form fields
    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setLocalData(prev => ({ ...prev, [name]: value }));
        setTouched(prev => ({ ...prev, [name]: true }));
    };

    // Handle file upload changes
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0] || null;
        setLocalData(prev => ({
            ...prev,
            [name]: file,
        }));
        setTouched(prev => ({ ...prev, [name]: true }));
    };

    // Handle form submission
    const handleSubmit = () => {
        if (!isFormValid) return;

        // Mark all fields as touched before saving
        const allTouched = {};
        Object.keys(localData).forEach(field => {
            allTouched[field] = true;
        });
        setTouched(allTouched);

        onSave(localData);
    };

    return (
        <Card className="shadow-lg p-4 mb-4 bg-light rounded">
            <ContactFormSection
                formData={localData}
                handleChange={handleFieldChange}
                handleFileChange={handleFileChange}
                formErrors={formErrors}
                touched={touched}
            />
            <div className="d-flex justify-content-end mt-4">
                <Button
                    variant={isFormValid ? "success" : "secondary"}
                    onClick={handleSubmit}
                    className="me-2 shadow-sm"
                    disabled={!isFormValid}
                    style={{
                        opacity: isFormValid ? 1 : 0.6,
                        cursor: isFormValid ? 'pointer' : 'not-allowed'
                    }}
                >
                    <FaCheck className="me-1" /> {t('save')}
                </Button>
                <Button variant="secondary" onClick={onCancel} className="shadow-sm">
                    <FaTimes className="me-1" /> {t('cancel')}
                </Button>
            </div>
        </Card>
    );
};

export default ContactEditor;